/*
 * Trafford product image slider (Swiper). Full-bleed strip with arrows + bullets,
 * matching the homepage past-collections style. Clicking a slide opens a swipeable
 * fullscreen lightbox (a second Swiper). No-op without Swiper.
 */
(function () {
  function initSlider(root) {
    if (!window.Swiper || root.dataset.swInit === '1') return;
    var stripEl = root.querySelector('[data-twc-swiper]');
    if (!stripEl) return;

    /* eslint-disable no-new */
    new window.Swiper(stripEl, {
      slidesPerView: 'auto',
      spaceBetween: 6,
      grabCursor: true,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: root.querySelector('[data-twc-prev]'),
        nextEl: root.querySelector('[data-twc-next]')
      },
      pagination: {
        el: root.querySelector('[data-twc-pagination]'),
        type: 'progressbar'
      }
    });

    /* ---- lightbox (the <dialog> right after .twc-slider) ---- */
    var dialog = root.nextElementSibling;
    if (dialog && dialog.tagName === 'DIALOG') {
      // Drive show/hide from inline styles so the closed dialog is guaranteed
      // hidden even if a stale combined styles.css still forces display on it.
      dialog.style.display = 'none';
      var lb = null;
      var thumbs = dialog.querySelectorAll('[data-twc-lb-thumb]');
      function setActiveThumb(i) {
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', parseInt(t.getAttribute('data-twc-lb-thumb'), 10) === i);
        });
        var active = dialog.querySelector('.twc-lightbox__thumb.is-active');
        if (active && active.scrollIntoView) active.scrollIntoView({ inline: 'center', block: 'nearest' });
      }
      function ensureLb() {
        if (lb) return lb;
        lb = new window.Swiper(dialog.querySelector('[data-twc-lb-swiper]'), {
          grabCursor: true,
          observer: true,
          observeParents: true,
          keyboard: { enabled: true },
          navigation: {
            prevEl: dialog.querySelector('[data-twc-lb-prev]'),
            nextEl: dialog.querySelector('[data-twc-lb-next]')
          },
          on: {
            slideChange: function () { setActiveThumb(this.activeIndex); }
          }
        });
        // Center each slide's image via inline styles: Swiper's own .swiper-slide
        // rules load after our bundle and would otherwise leave the slide display:block
        // (image pinned left). Inline styles win regardless of CSS build/cache timing.
        dialog.querySelectorAll('.twc-lightbox__slide').forEach(function (s) {
          s.style.display = 'flex';
          s.style.alignItems = 'center';
          s.style.justifyContent = 'center';
        });
        thumbs.forEach(function (t) {
          t.addEventListener('click', function () {
            var i = parseInt(t.getAttribute('data-twc-lb-thumb'), 10) || 0;
            lb.slideTo(i);
          });
        });
        return lb;
      }
      function openLb(idx) {
        // Open the dialog FIRST so Swiper measures a real (non-zero) width,
        // then init/recalc and jump to the clicked slide once it's visible.
        dialog.style.display = 'flex';
        if (typeof dialog.showModal === 'function') dialog.showModal();
        ensureLb();
        lb.slideTo(idx, 0);
        setActiveThumb(idx);
        window.requestAnimationFrame(function () {
          lb.update();
          lb.slideTo(idx, 0);
        });
        if (window.gsap) {
          window.gsap.fromTo(dialog, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.22, ease: 'power2.out' });
        }
      }
      function closeLb() {
        if (window.gsap) {
          window.gsap.to(dialog, {
            autoAlpha: 0, duration: 0.2, ease: 'power2.in',
            onComplete: function () {
              dialog.close();
              dialog.style.display = 'none';
              window.gsap.set(dialog, { clearProps: 'opacity,visibility' });
            }
          });
        } else {
          dialog.close();
          dialog.style.display = 'none';
        }
      }
      root.querySelectorAll('[data-twc-open]').forEach(function (slide) {
        slide.addEventListener('click', function () {
          openLb(parseInt(slide.getAttribute('data-twc-open'), 10) || 0);
        });
      });
      var closeBtn = dialog.querySelector('[data-twc-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeLb);
      dialog.addEventListener('click', function (e) { if (e.target === dialog) closeLb(); });
      dialog.addEventListener('cancel', function (e) { e.preventDefault(); closeLb(); });
    }

    root.dataset.swInit = '1';
  }

  function initAll(rootEl) {
    if (!window.Swiper) return;
    (rootEl || document).querySelectorAll('.twc-slider').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
